'use client';

import { useEffect } from 'react';
import { EPlatform } from '@/utils/enums/platform-enum';

interface Banner1AnimationProps {
  deviceType: EPlatform;
}

export default function Banner1Animation({ deviceType }: Banner1AnimationProps) {
  useEffect(() => {
    // 只在PC端启用动画
    if (deviceType !== EPlatform.WEB) {
      return;
    }

    // Banner1 初始动画
    const timer = setTimeout(() => {
      const leftImage = document.querySelector('.banner1 .left-image');
      const rightImage = document.querySelector('.banner1 .right-image');

      if (leftImage) {
        leftImage.classList.add('fadeInUpAnimate');
      }

      setTimeout(() => {
        if (rightImage) {
          rightImage.classList.add('fadeInUpAnimate');
        }
      }, 500);
    }, 1000);

    return () => clearTimeout(timer);
  }, [deviceType]);

  return null;
}
